export enum LayerStatus {
  Quoting = 'Quoting',
  Reviewing = 'Reviewing',
  Bound = 'Bound',
  PolicyIssued = 'PolicyIssued',
}
